import barba from '@barba/core';
import { gsap } from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { setupApproachAnimations } from './approach.js';
import { Observer } from "gsap/Observer";
import { Slideshow } from './slideshow.js';
import { initHeaderScroll, destroyHeaderScroll } from './headerScroll';
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';
import SplitType from 'split-type';
// import HoverImgFx2 from './studiohover';
// import TouchImgFx2 from './studiotouch';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Observer);
let mm = gsap.matchMedia(), breakPoint = 992;


const mobileMenu = (container) => {
    const select = (elem) => container.querySelector(elem);
    const selectAll = (elem) => [...container.querySelectorAll(elem)];
    const btnMenu = select('#btnMenu');
    const btnCloseMenu = select('#btnCloseMenu');
    const menuDrawer = select('#menuDrawer');
    const menuDrawerSubWrapper = selectAll('#menuDrawer .subWrapper');
    document.body.classList.remove('overflowHidden');
    btnMenu.addEventListener('click', (event) => {
        console.log('open menu');
        event.preventDefault();
        document.body.classList.add('overflowHidden');
        menuDrawer.style.display = 'flex';
        setTimeout(function() {
            btnCloseMenu.classList.add('active');
            menuDrawerSubWrapper.forEach((item) => {
                item.classList.add('active');
            });
        }, 100);
        // console.log('open menu');
    });
    btnCloseMenu.addEventListener('click', (event) => {
        event.preventDefault();
        document.body.classList.remove('overflowHidden');
        menuDrawer.style.display = 'none';
        btnCloseMenu.classList.remove('active');
        menuDrawerSubWrapper.forEach((item) => {
            item.classList.remove('active');
        });
        // console.log('close menu');
    });
}

export default mobileMenu;

const initDetailsPage = (container) => {
    const select = (elem) => container.querySelector(elem);
    //Copy link
    const copyLink = select('#copyLink');
    copyLink.addEventListener('click', (ev) => {
        ev.preventDefault();
        let text = copyLink.textContent;
        let before = copyLink.dataset.before;
        let after = copyLink.dataset.after;
        let url = window.location.href;
        copyLink.innerHTML = `${after}`;
        copyLink.classList.add('ok');
        setTimeout(function(){
            copyLink.innerHTML = `${before}`;
            copyLink.classList.remove('ok');
        },1200);
        navigator.clipboard.writeText(`${url}`);
    });
    //GLightbox
    const lightbox = GLightbox({
        touchNavigation: true,
        loop: false,
        draggable: false,
        autoplayVideos: true,
        plyr: {
            config: {
            ratio: '16:9',
            muted: false,
            hideControls: true,
            youtube: {
                noCookie: true,
                rel: 0,
                showinfo: 0,
                iv_load_policy: 3
            }
            }
        }
    });

    lightbox.on('open', () => {
        setTimeout(() => {
            const player = lightbox.getSlidePlayerInstance(0);

            if (player?.ready) {
                player.on('ended', () => lightbox.close());
            }
        }, 500);
    });

    //Split text
    const fxQuotesEn = [...document.querySelectorAll('.csWrap__quote[data-splitting-fx-en]')];
    const fxQuotesTc = [...document.querySelectorAll('.csWrap__quote[data-splitting-fx-tc]')];
    let quotesSplitEn, quotesSplitTc; 
    fxQuotesEn.forEach(quote => {
        quotesSplitEn = new SplitType (quote , {
            types: "lines, words"
        });
        gsap.fromTo(quote.querySelectorAll('.word'), {
            y: 60
        }, 
        {
            ease: 'circ.out',
            y:0,
            stagger: 0.05,
            scrollTrigger: {
                trigger: quote,
                start: 'top bottom-=40%',
                end: 'center center-=30%',
                scrub: true
                //markers: true
            }
        });
    });
    fxQuotesTc.forEach(quote => {
        quotesSplitTc = new SplitType (quote , {
            types: "lines, words, chars"
        });
        gsap.fromTo(quote.querySelectorAll('.char'), {
            'will-change': 'opacity',
            opacity: 0.1
        }, 
        {
            ease: 'circ.out',
            opacity:1,
            stagger: 0.05,
            scrollTrigger: {
                trigger: quote,
                start: 'top bottom-=40%',
                end: 'center center-=20%',
                scrub: true
            }
        });
    });
}

const initHomeSlideshow = (container) => {
	const select = (elem) => container.querySelector(elem);
	const slides = select('.slides');
	const slideshow = new Slideshow(slides);

	slideshow.autoplay(5000); // e.g., every 5 sec

	const stopAutoplayTemporarily = () => {
		slideshow.stopAutoplayTemporarily(5000); // pass same interval as autoplay
	};

	// Buttons
	container.querySelector('.slides-nav__item--prev').addEventListener('click', () => {
		stopAutoplayTemporarily();
		slideshow.prev();
	});
	container.querySelector('.slides-nav__item--next').addEventListener('click', () => {
		stopAutoplayTemporarily();
		slideshow.next();
	});

	// GSAP Observer
	Observer.create({
		type: 'wheel,touch,pointer',
		onDown: () => {
			stopAutoplayTemporarily();
			slideshow.prev();
		},
		onUp: () => {
			stopAutoplayTemporarily();
			slideshow.next();
		},
		wheelSpeed: -1,
		tolerance: 10
	});

	const pageWrapper = select('.pageWrapper');
	const tl = gsap.timeline({
		defaults: {
			ease: 'expo.inOut',
			duration: 1
		}
	});
	tl.to(pageWrapper, {
		autoAlpha: 1
	}, 0);
	return tl;
};

const enterCSDetailsAnimation = (container) => {
    const select = (elem) => container.querySelector(elem);
    const selectAll = (elem) => [...container.querySelectorAll(elem)];
    const card = select('.card');
    const cardImage = select('.card__image');
    const tagline = select('.hero__tagline');
    let taglineHeight = tagline.offsetHeight + 30;
    const title = select('.hero__title');
    const subnav = select('.subnav');
    // const btmLine = select('.btmLine');
    const logoDesign = select('.logoDesign');
    const logoColab = select('.logoColab');
    const lang = select('.lang');
    const tl = gsap.timeline({
        defaults: {
            ease: 'expo.inOut',
            duration: 1.5
        }
    });

    mm.add({
        isDesktop: `(min-width: ${breakPoint + 1}px)`,
        isMobile: `(max-width: ${breakPoint}px)`
    },
    (context) => {
        let { isDesktop, isMobile } = context.conditions;
        tl.to(title, {
            bottom: isDesktop ? "9%" : "calc(7% + " + taglineHeight +  "px)"
        }, 0);
    }
    );

    tl.to([logoDesign, logoColab], {
        autoAlpha:0
    }, 0).from(lang, {
        autoAlpha:0
    }, 0).to(cardImage, {
        scale: 1
    }, 0).to(card, {
        height: "100%",
        width: "100%"
    }, 0).to(tagline, {
        bottom: "8%"
    }, 0).to(title, {
        //bottom: "10%"
    }, 0).to(subnav, {
        autoAlpha: 1
    }, 0.3).from(subnav, {
        xPercent:2
    }, 0.3);
    
    return tl;

    mm.revert();
}

const enterCSIndexAnimation = (container) => {
    const select = (elem) => container.querySelector(elem);
    const selectAll = (elem) => [...container.querySelectorAll(elem)];
    // const logoCo = select('.logoCo');
    // const logoDesign = select('.logoDesign');
    // const logoColab = select('.logoColab');
    // const nav = select('nav');
    // const lang = select('.lang');
    const casestudyWrapper = select('.casestudyWrapper');

    const tl = gsap.timeline({
        defaults: {
            ease: 'expo.inOut',
            duration: 0.8
        }
    });

    // tl.to(casestudyWrapper, {
    //     autoAlpha:1
    // }, 0.2).from(casestudyWrapper, {
    //     y:50
    // }, 0.2);

    // return tl;
}

const enterWorkDetailsAnimation = (container) => {
    const select = (elem) => container.querySelector(elem);
    const selectAll = (elem) => [...container.querySelectorAll(elem)];
    const subnav = select('.subnav');
    const logoDesign = select('.logoDesign');
    const logoColab = select('.logoColab');
    const lang = select('.lang');
    const pageWrapper = select('.pageWrapper');
    const tl = gsap.timeline({
        defaults: {
            ease: 'expo.inOut',
            duration: 1.2
        }
    });

    tl.to([logoDesign, logoColab], {
        autoAlpha:0
    }, 0).from(lang, {
        autoAlpha:0
    }, 0).to(subnav, {
        autoAlpha: 1
    }, 0.3).from(subnav, {
        xPercent:2
    }, 0.3).to(pageWrapper, {
        autoAlpha: 1
    }, 0).from(pageWrapper, {
        y:-80
    }, 0);
    
    return tl;
}

const enterApproachAnimation = (container) => {
    const select = (elem) => container.querySelector(elem);
    const selectAll = (elem) => [...container.querySelectorAll(elem)];
    const pageWrapper = select('.pageWrapper');
    const tl = gsap.timeline({
        defaults: {
            ease: 'expo.inOut',
            duration: 1
        }
    });
    tl.to(pageWrapper, {
        autoAlpha: 1,
        y:0,
        delay:0.1
    }, 0);

    return tl;
}

const enterStudioAnimation = (container) => {
    const select = (elem) => container.querySelector(elem);
    const selectAll = (elem) => [...container.querySelectorAll(elem)];
    const pageWrapper = select('.pageWrapper');
    const tl = gsap.timeline({
        defaults: {
            ease: 'expo.inOut',
            duration: 1
        }
    });
    tl.to(pageWrapper, {
        autoAlpha: 1,
        y:0,
        delay:0.1
    }, 0);

    return tl;
}

const resetMainToFixed = () => {
    window.scrollTo({ top: 0, behavior: 'auto' });
    const main = document.querySelector('main');
    main.classList.add('fixed');
}

const leaveGeneral = (container) => {
    ScrollTrigger.getAll().forEach(st => st.kill());
    gsap.killTweensOf("*");
    destroyHeaderScroll();
    const select = (elem) => container.querySelector(elem);
    const selectAll = (elem) => [...container.querySelectorAll(elem)];
    const header = select('#header');
    const nullWrapper = select('.nullWrapper');
    const menuDrawer = select('#menuDrawer');
    const tl = gsap.timeline({
        defaults: {
            duration: 0
        }
    });

    tl.to([header, nullWrapper, menuDrawer], {
        autoAlpha:0
    }, 0);

    console.log('complete leave general')
    
    return tl;
}

/* For Studio page - initiate hover effects of the photos */
// function initStudioHoverEffects() {
//     if ("ontouchstart" in document.documentElement) {
//         if (document.querySelector(".studio")) {
//             [...document.querySelectorAll('[data-fx="2"] a')].forEach(link => new TouchImgFx2(link));
//         }
//     } else {
//         if (document.querySelector(".studio")) {
//             [...document.querySelectorAll('[data-fx="2"] a')].forEach(link => new HoverImgFx2(link));
//         }
//     }
// }

/* For Case Study Details Page and Work Details Page: Applying Inline Styles */
function restoreInlineStyles(next) {
    console.log("🚀 Page transitioned, restoring block styles...");

    // Remove previously injected inline styles
    document.querySelectorAll("[data-barba-inline-style]").forEach(style => style.remove());

    // Create a temporary DOM element to parse next.html
    const tempDom = document.createElement("html");
    tempDom.innerHTML = next.html;

    // Find all inline <style> tags inside the <head> of the fetched HTML
    const nextStyles = tempDom.querySelectorAll("head style");

    if (nextStyles.length === 0) {
        console.warn("⚠️ No inline styles found in next page’s <head>. They may be dynamically injected by WordPress.");
        return;
    }

    console.log(`🎨 Found ${nextStyles.length} inline styles. Moving to <head>...`);

    nextStyles.forEach(style => {
        const newStyle = document.createElement("style");
        newStyle.innerHTML = style.innerHTML; // Copy the CSS content
        newStyle.setAttribute("data-barba-inline-style", ""); // Mark the styles for easy removal
        document.head.appendChild(newStyle);
    });

    console.log("✅ Inline styles successfully reapplied and cleaned up!");
}

/* Animate images and text globally*/
function animateImagesText() {
    const elements = gsap.utils.toArray('.fade-up');

    elements.forEach(el => {
        const bounds = el.getBoundingClientRect();
        // console.log('fade-up element:', el, 'top:', bounds.top, 'height:', bounds.height, 'y transform:', gsap.getProperty(el, 'y'));

        // Only create ScrollTrigger if element is NOT visible yet
        if (bounds.top > window.innerHeight || bounds.bottom < 0) {
            gsap.fromTo(el,
                { opacity: 0, y: 40 },
                {
                    opacity: 1,
                    y: 0,  // explicit end state — never left hanging
                    duration: 1.5,
                    ease: 'power2.out',
                    onComplete: () => gsap.set(el, { clearProps: 'transform,opacity' }),
                    scrollTrigger: {
                        trigger: el,
                        start: 'top 90%',
                        end: 'top 30%',
                        toggleActions: 'play none none reverse',
                    }
                }
            );
        } else {
            // Force it to be fully visible immediately (no animation)
            gsap.set(el, { opacity: 1, y: 0 });
        }
    });

    // Similarly for .wp-block-cover__image-background
    const covers = gsap.utils.toArray('.wp-block-cover__image-background');

    covers.forEach(image => {
        const bounds = image.getBoundingClientRect();

        if (bounds.top > window.innerHeight || bounds.bottom < 0) {
            gsap.from(image, {
                scale: 1.3,
                opacity: 0,
                duration: 1.2,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: image,
                    start: 'top 80%',
                    end: 'top 30%',
                    toggleActions: 'play none none reverse',
                }
            });
        } else {
            gsap.set(image, { opacity: 1, scale: 1 });
        }
    });

    // Fade-in text
    const fadeIns = gsap.utils.toArray('.fade-in');

    fadeIns.forEach(el => {
        const bounds = el.getBoundingClientRect();

        if (bounds.top > window.innerHeight || bounds.bottom < 0) {
            gsap.from(el, {
                opacity: 0,
                duration: 1,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: el,
                    start: 'top 90%',
                    toggleActions: 'play none none reverse',
                }
            });
        } else {
            gsap.set(el, { opacity: 1 });
        }
    });
}

export const initBarba = () => {
    if (!document.body.classList.contains("no-barba")) {
        barba.init({
            prefetch: true,
            timeout: 10000, // 25s temp only: Set timeout to 2.5 seconds
            debug: true,
            prevent: ({ href }) => href.includes("/work-index/"),
            transitions: [
            {   name: 'casestudy-details-once',
                to:{
                    namespace: ['casestudydetails']
                },
                once({ next }) {
                    console.log("🔥 Running once transition for casestudy-details");
                    return enterCSDetailsAnimation(next.container).then(() => {
                        animateImagesText();
                        ScrollTrigger.refresh(true);
                    });
                }
            },
            {   name: 'casestudy-from-index',
                sync: false,
                from: {
                    namespace: ['casestudy']
                },
                to:{
                    namespace: ['casestudydetails']
                },
                beforeLeave() {
                    destroyHeaderScroll();
                },
                beforeEnter({ next }) {
                    restoreInlineStyles(next); // Clean up old styles and reapply new ones
                },
                enter({ next }) {
                    console.log("enter triggered!", next);
                    return enterCSDetailsAnimation(next.container).then(() => {
                        animateImagesText();
                        ScrollTrigger.refresh(true);
                    });
                }
            },
            {   name: 'casestudy-from-elsewhere',
                sync: false,
                from: {
                    namespace: ['casestudydetails', 'workdetails', 'home']
                },
                to:{
                    namespace: ['casestudydetails']
                },
                leave({ current }) {
                    return leaveGeneral(current.container).then(() => {
                        resetMainToFixed();
                    });
                },
                beforeEnter({ next }) {
                    restoreInlineStyles(next); // Clean up old styles and reapply new ones
                },
                enter({ next }) {
                    return enterCSDetailsAnimation(next.container).then(() => {
                        animateImagesText();
                        ScrollTrigger.refresh(true);
                    });
                }
            },
            {   name: 'casestudy-index-from-elsewhere',
                sync: false,
                from: {
                    namespace: ['casestudy', 'casestudydetails', 'workdetails', 'approach', 'studio', 'home']
                },
                to:{
                    namespace: ['casestudy']
                },
                leave({ current }) {
                    return leaveGeneral(current.container).then(() => {
                        resetMainToFixed();
                    });
                },
                enter({ next }) {
                    return enterCSIndexAnimation(next.container)
                }
            },
            {   name: 'casestudy-index-once',
                to:{
                    namespace: ['casestudy']
                },
                once({ next }) {
                    return enterCSIndexAnimation(next.container)
                }
            },
            {    name: 'workdetails-from-elsewhere',
                sync: false,
                from: {
                    namespace: ['workdetails', 'casestudydetails', 'home']
                },
                to:{
                    namespace: ['workdetails']
                },
                leave({ current }) {
                    return leaveGeneral(current.container).then(() => {
                        resetMainToFixed();
                    });
                },
                beforeEnter({ next }) {
                    restoreInlineStyles(next); // Clean up old styles and reapply new ones
                },
                enter({ next }) {
                    return enterWorkDetailsAnimation(next.container).then(() => {
                        animateImagesText();
                        ScrollTrigger.refresh(true);
                    });
                }
            },
            {   name: 'workdetails-once',
                to:{
                    namespace: ['workdetails']
                },
                once({ next }) {
                    return enterWorkDetailsAnimation(next.container).then(() => {
                        animateImagesText();
                        ScrollTrigger.refresh(true);
                    });
                }
            },
            {   name: 'approach-from-elsewhere',
                sync: true,
                from: {
                    namespace: ['approach', 'casestudy', 'casestudydetails', 'workdetails' , 'studio', 'home']
                },
                to:{
                    namespace: ['approach']
                },
                leave({ current }) {
                    return leaveGeneral(current.container).then(() => {
                        resetMainToFixed();
                    });
                },
                enter({ next }) {
                    return enterApproachAnimation(next.container)
                },
                afterEnter() {
                    window.scrollTo(0, 0);
                    
                    setTimeout(() => {
                        setupApproachAnimations();
                        ScrollTrigger.refresh(true);
                    }, 300);
                },
                beforeLeave() {
                    destroyHeaderScroll();
                    ScrollTrigger.getAll().forEach(st => st.kill());
                    gsap.killTweensOf("*");
                    // Clear all inline styles applied by GSAP
                    gsap.set([
                        ".circle-1", ".circle-2", ".circle-3",
                        "#circleContainer",
                        ".stageText", ".descText",
                        "#stageTextContainer", "#descTextContainer",
                        "#endTextContainer"
                    ], {
                        clearProps: "all"
                    });
                }
            },
            {   name: 'approach-once',
                to:{
                    namespace: ['approach']
                },
                once({ next }) {
                    console.log("Approach!!!");
                    enterApproachAnimation(next.container);
                    setupApproachAnimations();
                }
            },
            {   name: 'studio-from-elsewhere',
                sync: true,
                from: {
                    namespace: ['studio', 'casestudy', 'casestudydetails', 'workdetails', 'approach', 'home']
                },
                to:{
                    namespace: ['studio']
                },
                leave({ current }) {
                    return leaveGeneral(current.container).then(() => {
                        resetMainToFixed();
                    });
                },
                enter({ next }) {
                    return enterStudioAnimation(next.container);
                    // return enterStudioAnimation(next.container).then(() => {
                    //     requestAnimationFrame(() => {
                    //         initStudioHoverEffects();
                    //     });
                    // });
                }
            },
            {   name: 'studio-once',
                to:{
                    namespace: ['studio']
                },
                once({ next }) {
                    console.log("Studio!!!!");
                    // initStudioHoverEffects();
                    return enterStudioAnimation(next.container)
                }
            },
            {   name: 'home-from-elsewhere',
                sync: true,
                from: {
                    namespace: ['home', 'casestudy', 'approach', 'studio', 'casestudydetails', 'workdetails']
                },
                to:{
                    namespace: ['home']
                },
                leave({ current }) {
                    return leaveGeneral(current.container).then(() => {
                        resetMainToFixed();
                    });
                },
                enter({ next }) {
                    return initHomeSlideshow(next.container)
                }
            },
            {   name: 'home-once',
                to:{
                    namespace: ['home']
                },
                once({ next }) {
                    return initHomeSlideshow(next.container)
                }
            }],
            views: [
            {   namespace: 'home',
                afterEnter({ next }) {
                    mobileMenu(next.container);
                }
            },
            {   namespace: 'casestudy',
                afterEnter({ next }) {
                    mobileMenu(next.container);
                }
            },
            {   namespace: 'approach',
                afterEnter({ next }) {
                    mobileMenu(next.container);
                }
            },
            {   namespace: 'studio',
                afterEnter({ next }) {
                    mobileMenu(next.container);
                }
            },
            {   namespace: 'casestudydetails',
                afterEnter({ next }) {
                    initDetailsPage(next.container);
                    mobileMenu(next.container);
                }
            },
            {   namespace: 'workdetails',
                afterEnter({ next }) {
                    initDetailsPage(next.container);
                    mobileMenu(next.container);
                }
            }],
            debug: true
        });
    }
};